module.exports = __webpack_public_path__ + "img/Mirta-egypt-white.662f1af7.png";